// src/api/cookie.js

/**
 * Reads a cookie by name from document.cookie.
 */
function getCookieValue(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

export { getCookieValue };